import React, {useContext, Fragment} from 'react';
import styled from 'styled-components';
import {Auth} from 'aws-amplify';
import {UserData} from '../../context';
import DXCONCOLOR from '../../images/dxConnectLogoColor.svg'
import {Link} from 'react-router-dom';

const Navbar = props => {

  const user = useContext(UserData) || {};

  async function handleSignout() {
    try {
      await Auth.signOut()
    } catch(err) {
      console.error('Error signing out user',err);
    }
  }

  let environment = user && user.config && user.config.env
  if (environment === undefined || environment === 'prod') {
    environment = ''
  } else {
    environment = ` - ${environment}`
  }

  return (
    <Fragment>
    <NavWrapper>
      <LogoWrapper>
        <img width={120} src={DXCONCOLOR} alt='DreamEx Connect' />
        {/* <DreamExLogo width={120} color='#555' /> */}
      </LogoWrapper>
      <span style={{ marginLeft: 190}}>
        {props.navItems.map(item => (
          <MenuItem
            key={`link_${item.title}`}
            to={item.link}
            exact={item.exact ? 1 : 0}
          >{item.title}</MenuItem>
        ))}
        <SignoutItem onClick={handleSignout}>SIGN OUT</SignoutItem>
      </span>
      {/* <NavRight>
        <Greeting>{`Hello, ${user.username}${environment}`}</Greeting>
        <VerticalAlign>
          <Button color='orange' small click={handleSignout}>SIGN OUT</Button>
        </VerticalAlign>
      </NavRight> */}

    </NavWrapper>
    </Fragment>

  );
};

const NavWrapper = styled.div`
  height: 65px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  background: #fefeff;
  line-height: 65px;
  box-shadow: 0 4px 2px -2px rgba(200,200,200,1);
  z-index: 5000;
`;

const LogoWrapper = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 20px;
`;

export const MenuItem = styled(Link)`
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #555;
  font-weight: 500;
  font-size: 14px;
  padding-left: 15px;
  padding-right: 15px;
  transition: 0.3s ease all;

  :hover {
    background: rgba(0,0,0,0.05);
    color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
    text-decoration: none;
  }
`;

export const SignoutItem = styled.span`
  display: inline-block;
  height: 30px;
  line-height: 30px;
  color: #555;
  font-weight: 500;
  font-size: 14px;
  padding-left: 15px;
  padding-right: 15px;
  transition: 0.3s ease all;
  cursor: pointer;

  :hover {
    background: rgba(0,0,0,0.05);
    color: ${({theme:{primaryAccentColor}}) => primaryAccentColor};
    text-decoration: none;
  }
`;


export default Navbar;
